export const defaultViewSearchTags = {
  breakfast: [
    {
      title: "Keto",
      ids: ["wp-us-tag-1", "wp-es-tag-1", "wp-se-tag-1"],
    },
    {
      title: "Easy",
      ids: ["wp-us-tag-5", "wp-es-tag-5", "wp-se-tag-5"],
    },
    {
      title: "Vegetarian",
      ids: ["wp-us-tag-1393", "wp-es-tag-1027", "wp-se-tag-1102"],
    },
    {
      title: "Budget",
      ids: ["wp-us-tag-942"],
    },
    {
      title: "High protein",
      ids: ["wp-us-tag-1401", "wp-es-tag-1033", "wp-se-tag-1106"],
    },

    {
      title: "Dairy free",
      ids: ["wp-us-tag-1394", "wp-es-tag-1028", "wp-se-tag-1103"],
    },
    {
      title: "Eggs",
      ids: [
        "wp-us-tag-393",
        "wp-us-tag-1352",
        "wp-es-tag-152",
        "wp-es-tag-975",
        "wp-se-tag-416",
        "wp-se-tag-1079",
      ],
    },
    {
      title: "Egg free",
      ids: ["wp-us-tag-586"],
    },
  ],
  lunch: [
    {
      title: "Keto",
      ids: ["wp-us-tag-1", "wp-es-tag-1", "wp-se-tag-1"],
    },
    {
      title: "Easy",
      ids: ["wp-us-tag-5", "wp-es-tag-5", "wp-se-tag-5"],
    },
    {
      title: "Vegetarian",
      ids: ["wp-us-tag-1393", "wp-es-tag-1027", "wp-se-tag-1102"],
    },
    {
      title: "Budget",
      ids: ["wp-us-tag-942"],
    },
    {
      title: "High protein",
      ids: ["wp-us-tag-1401", "wp-es-tag-1033", "wp-se-tag-1106"],
    },

    {
      title: "Dairy free",
      ids: ["wp-us-tag-1394", "wp-es-tag-1028", "wp-se-tag-1103"],
    },
    {
      title: "Salad",
      ids: ["wp-us-tag-380", "wp-es-tag-178", "wp-se-tag-404"],
    },
    {
      title: "Poultry",
      ids: ["wp-us-tag-317", "wp-us-tag-1357", "wp-es-tag-982", "wp-se-tag-411", "wp-se-tag-1086"],
    },
  ],
  dinner: [
    {
      title: "Keto",
      ids: ["wp-us-tag-1", "wp-es-tag-1", "wp-se-tag-1"],
    },
    {
      title: "Easy",
      ids: ["wp-us-tag-5", "wp-es-tag-5", "wp-se-tag-5"],
    },
    {
      title: "Vegetarian",
      ids: ["wp-us-tag-1393", "wp-es-tag-1027", "wp-se-tag-1102"],
    },
    {
      title: "Budget",
      ids: ["wp-us-tag-942"],
    },
    {
      title: "High protein",
      ids: ["wp-us-tag-1401", "wp-es-tag-1033", "wp-se-tag-1106"],
    },

    {
      title: "Dairy free",
      ids: ["wp-us-tag-1394", "wp-es-tag-1028", "wp-se-tag-1103"],
    },
    {
      title: "Ground beef",
      ids: ["wp-us-tag-572"],
    },
    {
      title: "Poultry",
      ids: ["wp-us-tag-317", "wp-us-tag-1357", "wp-es-tag-982", "wp-se-tag-411", "wp-se-tag-1086"],
    },
  ],
};
